<template>
  <div id="app">
      <akheader></akheader>
      <akrankings v-if="curRouteName == 'root'"></akrankings>
      <router-view></router-view>
      <akfooter></akfooter>
  </div>
</template>
<script>
/* eslint-disable */
import akheader from './components/AKHeader.vue'
import akrankings from './components/AKRankings.vue'
import akfooter from './components/AKFooter.vue'
import pc from './views/PC.vue'
import m from './views/M.vue'

export default {
  name: 'App',
  components: { akheader, akrankings, akfooter, pc, m },
  data() {
    return {
        curRouteName: '',
    }
  },
  beforeCreate: function () {
    // console.log(this.$utils.isMobile())
    // this.mobileMode = this.$utils.isMobile()
    // console.log(this.mobileMode)
  },
  created: function () {
    window.vue = this
    this.curRouteName = this.$route.name
  },
    beforeUpdate() {
      this.curRouteName = this.$route.name
    },
}
</script>
<style lang="less">
    @import "style/ak.less";
</style>
